import { render, staticRenderFns } from "./IndexChart.vue?vue&type=template&id=3a23aec3&scoped=true"
import script from "./IndexChart.vue?vue&type=script&lang=js"
export * from "./IndexChart.vue?vue&type=script&lang=js"
import style0 from "./IndexChart.vue?vue&type=style&index=0&id=3a23aec3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23aec3",
  null
  
)

export default component.exports